import * as React from 'react';
import _ from 'lodash';
import Box from '@mui/material/Box';
import AnimatedDie from './../../assets/../assets/images/board/dice/animated_die.gif';
import DieOne from './../../assets/../assets/images/board/dice/die_1.gif';
import DieTwo from './../../assets/../assets/images/board/dice/die_2.gif';
import DieThree from './../../assets/../assets/images/board/dice/die_3.gif';
import DieFour from './../../assets/../assets/images/board/dice/die_4.gif';
import DieFive from './../../assets/../assets/images/board/dice/die_5.gif';
import DieSix from './../../assets/../assets/images/board/dice/die_6.gif';
import "./styles.scss";

export type Props = {
  throwDice: boolean,
  diceSideNumbers: Array<number>,
  numberOfDices: number,
  showDiceResult: boolean
}

const getDiceSides = (diceSideNumbers: Array<number>): Array<string> => {
  const dieSides = [DieOne, DieTwo, DieThree, DieFour, DieFive, DieSix];
  return diceSideNumbers.map((number) => {
    return dieSides[number - 1];
  });
}

const getDiceMoving = (diceSideNumbers: Array<number>) => {
  return (
    <Box className='diceContainer' >
         {diceSideNumbers.map((die, index) => <img className='diceChildModal' src={AnimatedDie} key={index} alt="" />)}
    </Box>
  )
}

const getDefaultDice = (numberOfDices:number) => {
  const diceSideNumbers= [];
  for (let i=0; i<numberOfDices; i++){
    diceSideNumbers.push(1);
  }

  return (
    <Box className='diceContainer'>
      {diceSideNumbers.map((die, index) => <img  className='diceChild' src={DieTwo} key={index} alt="" />)}
    </Box>
  )
}

const getDiceResult = (diceSideNumbers: Array<number>) => {
  const dice = getDiceSides(diceSideNumbers);
  return (
    <Box  className='diceContainer'>
      {dice.map((die, index) => <img className='diceChildModal' src={die} key={index} alt="" />)}
    </Box>
  )
}

const getDice = (throwDice: boolean, diceSideNumbers: Array<number>,numberOfDices:number) => {
  return throwDice ? getDiceMoving(diceSideNumbers) : getDefaultDice(numberOfDices);
}

const Dice = (props: Props) => {
  const { showDiceResult, throwDice, diceSideNumbers, numberOfDices } = props;
  return (
    showDiceResult ? getDiceResult(diceSideNumbers) : getDice(throwDice, diceSideNumbers,numberOfDices)
  );
}

export default Dice;